const getConsolidationFacet = (variant)=>{
    const isSunglassesVariant = variant.__typename === 'SunglassesVariant';
    const isFrameVariant = variant.__typename === 'FrameVariant';
    const isReadyReaderVariant = variant.__typename === 'ReadyReaderVariant';
    const getFrameFeature = ()=>{
        if (isFrameVariant) {
            return variant.variantTypeDetails.frameFeatures;
        }
        if (isSunglassesVariant || isReadyReaderVariant) {
            return variant.variantTypeDetails.maybeFrameFeatures;
        }
        return undefined;
    };
    const getLensFeatures = ()=>{
        if (isFrameVariant) {
            return variant.variantTypeDetails.lensFeatures;
        }
        if (isSunglassesVariant || isReadyReaderVariant) {
            return variant.variantTypeDetails.maybeLensFeatures;
        }
        return undefined;
    };
    const frameFeatures = getFrameFeature();
    const lensFeatures = getLensFeatures();
    const frameSize = frameFeatures === null || frameFeatures === void 0 ? void 0 : frameFeatures.size;
    const frameColor = frameFeatures === null || frameFeatures === void 0 ? void 0 : frameFeatures.color.join(',');
    const lensColor = lensFeatures === null || lensFeatures === void 0 ? void 0 : lensFeatures.lensColor;
    const consolidationFacet = frameSize ? [
        frameColor,
        lensColor
    ].filter(Boolean).join('-') : null;
    return consolidationFacet;
};

export { getConsolidationFacet };
//# sourceMappingURL=get-consolidation-facet.js.map
